var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { raVisibilityHideForSmallOnly } from "@riseart/antd-provider/dist/website/variables.less";
import { gridCounterCls } from "./Counter.less";
function GridCounter(_ref) {
  var children = _ref.children;
  return children ? /* @__PURE__ */ React.createElement("span", {
    className: "".concat(gridCounterCls, " ").concat(raVisibilityHideForSmallOnly)
  }, children) : null;
}
__name(GridCounter, "GridCounter");
export {
  GridCounter
};
